function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Public_Transport"
}, /*#__PURE__*/React.createElement("path", {
  d: "M233.7 212.4c2.7-1.8 5.3-4 7.6-6.4 9.4-9.8 14.4-23.5 13.7-37.6L248.8 30C248 13.2 235 0 219.1 0H64.3C48.4 0 35.4 13.2 34.7 30l-6.3 138.3c-.6 14.1 4.4 27.8 13.7 37.6 2.3 2.5 4.9 4.6 7.6 6.4L0 283.5h34.1l10-14.3h195.1l10 14.3h34.2l-49.7-71.1zM113.4 28.3h56.7v70.9h-56.7V28.3zM56.7 169.6L63 31.3c.1-1.9 1.1-2.9 1.3-3H85v99.2h113.4V28.3h20.7c.3.1 1.3 1.1 1.4 3l6.3 138.3c.3 6.4-1.9 12.5-5.9 16.8-2.2 2.3-5.8 5-10.9 5H73.5c-5.1 0-8.7-2.7-10.9-5-4-4.3-6.2-10.4-5.9-16.8zm7.1 71.5l15-21.4h125.8l15 21.4H63.8z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "186",
  cy: "157.9",
  rx: "12.4",
  ry: "12.3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "97.4",
  cy: "157.9",
  rx: "12.4",
  ry: "12.3"
}))));